<template>
<div class="chapter">
<div class="inner_page">
<p class="pn"><span epub:type="pagebreak" id="page7" title="7"></span><a href="#/Text/Contents#P1"><span class="blue">Part One</span></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?03b20de9